import React from "react";
import { useTranslation } from "react-i18next";
import { OnboardingSteps } from "../../utils/constants";
import HowMuchWouldYouLikeToMake from "../onboarding/HowMuchWouldYouLikeToMake/HowMuchWouldYouLikeToMake";
import ReferralCodePage from "../onboarding/ReferralCodePage/ReferralCodePage";
import CreateUserNamePage from "../onboarding/CreateUserNamePage/CreateUserNamePage";
import SignUpPage from "../onboarding/SignUpPage/SignUpPage";
import SignUpSuccessfulPage from "../onboarding/SignUpSuccessfulPage/SignUpSuccessfulPage";
import SettingEarningsGoal from "../onboarding/SettingEarningsGoal/SettingEarningsGoal";
import useOnboardingSteps from "../../hooks/useOnboardingSteps";
import {
  extractOgTitleFromMainTitle,
  renderHeaders,
} from "../../utils/renderHeaders";

function SignUpStartFlowPage() {
  const { currentStep } = useOnboardingSteps();
  const { t } = useTranslation();

  let contentEl: JSX.Element;

  switch (currentStep) {
    case OnboardingSteps.SIGN_UP_SUCCESSFUL:
      contentEl = <SignUpSuccessfulPage />;
      break;
    case OnboardingSteps.SET_EARNINGS_GOALS:
      contentEl = <HowMuchWouldYouLikeToMake />;
      break;
    case OnboardingSteps.SETTING_EARNINGS_GOALS:
      contentEl = <SettingEarningsGoal />;
      break;
    case OnboardingSteps.SIGN_UP:
      contentEl = <SignUpPage />;
      break;
    case OnboardingSteps.USE_REFERRAL_CODE:
      contentEl = <ReferralCodePage />;
      break;
    case OnboardingSteps.CLAIM_USERNAME:
      contentEl = <CreateUserNamePage />;
      break;
    default:
      contentEl = <SignUpPage />;
  }

  return (
    <>
      {renderHeaders({
        title: t("metadata:sigma_onboarding_title"),
        description: t("metadata:sigma_onboarding_description"),
        ogTitle: extractOgTitleFromMainTitle(
          t("metadata:sigma_onboarding_title")
        ),
      })}
      {contentEl}
    </>
  );
}

export default SignUpStartFlowPage;
